function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createSetContactDetailsAction, createSetFilterLocationAction } from '../actions/partnersActions';
import { Constants } from '../../shared/utils/constants';
import { PartnersHost } from '../components/partnersHost';
import { connect } from 'react-redux';
import { withRouter } from '@shared/routerHistory';
export const mapStateToProps = (state, ownProps)=>{
    const serverRendering = !(typeof window !== 'undefined' && window.document);
    if (serverRendering) {
        return _object_spread_props(_object_spread({}, ownProps), {
            user: state.users,
            billingCountryCode: state.config.billingCountryCode,
            hostUrl: '',
            partnersUrl: '',
            partnersFixedSourceUrl: '',
            iframeBaseAddress: '',
            serverRendering: true
        });
    } else {
        var _state_partners, _state_partners1;
        const partnersIframeUrl = state.config.featureFlags.partnersTestMode ? state.config.partnersIframeUrlTest : state.config.partnersIframeUrl;
        const partnersFixedSourceUrl = state.config.locale ? `${partnersIframeUrl}/${state.config.locale}/${Constants.partnersIframe}` : `${partnersIframeUrl}/${Constants.partnersIframe}`;
        let partnersUrl = ownProps.location.pathname.replace(Constants.partnersAppSource, Constants.partnersIframe);
        partnersUrl = ownProps.location.search ? partnersUrl + ownProps.location.search : partnersUrl;
        const filterLocation = (_state_partners = state.partners) === null || _state_partners === void 0 ? void 0 : _state_partners.filterLocation;
        const contactDetails = (_state_partners1 = state.partners) === null || _state_partners1 === void 0 ? void 0 : _state_partners1.contactDetails;
        return _object_spread_props(_object_spread({}, ownProps), {
            user: state.users,
            billingCountryCode: state.config.billingCountryCode,
            hostUrl: window.location.href,
            iframeBaseAddress: partnersIframeUrl,
            partnersUrl: partnersUrl,
            partnersFixedSourceUrl: partnersFixedSourceUrl,
            filterLocation: filterLocation,
            contactDetails: contactDetails,
            serverRendering: serverRendering
        });
    }
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        storeFilterLocation: (filterLocation)=>{
            dispatch(createSetFilterLocationAction(filterLocation));
        },
        storeContactDetails: (contactDetails)=>{
            dispatch(createSetContactDetailsAction(contactDetails));
        }
    };
};
const PartnersHostContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnersHost));
export default PartnersHostContainer;
